import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2, Wallet } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const WalletSection = () => {
  const { toast } = useToast();

  const { data: walletBalance, isLoading: isLoadingWallet } = useQuery({
    queryKey: ['host-wallet-balance'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      const { data, error } = await supabase
        .from('wallet_balances')
        .select('*')
        .eq('user_id', user.id)
        .maybeSingle();

      if (error) throw error;
      
      // If no wallet exists, create one
      if (!data) {
        const { data: newWallet, error: createError } = await supabase
          .from('wallet_balances')
          .insert({
            user_id: user.id,
            balance: 0,
            currency: 'USD'
          })
          .select()
          .single();

        if (createError) throw createError;
        return newWallet;
      }

      return data;
    }
  });

  const handleWithdraw = async () => {
    toast({
      title: "Withdrawal Initiated",
      description: "Your withdrawal request has been submitted for processing.",
    });
  };

  if (isLoadingWallet) {
    return (
      <div className="flex items-center justify-center p-8">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Wallet className="h-5 w-5" />
          Wallet Balance
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Available Balance</p>
              <p className="text-2xl font-bold">${walletBalance?.balance.toFixed(2) || '0.00'}</p>
            </div>
            <Button onClick={handleWithdraw}>
              Withdraw Funds
            </Button>
          </div>
          <div className="text-sm text-muted-foreground">
            <p>Currency: {walletBalance?.currency || 'USD'}</p>
            <p>Last updated: {walletBalance?.updated_at ? new Date(walletBalance.updated_at).toLocaleDateString() : 'Never'}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};